const accountDetails = {
  accountDetails: {
    managePreferences: 'Zarządzaj preferencjami',
    email: 'E-mail',
    emailChangeText: 'Nadal musisz potwierdzić zmianę adresu e-mail!',
    confirmationText:
      'Wysłaliśmy wiadomość e-mail z potwierdzeniem na adres %{email}. Aby zmiana adresu e-mail zaczęła obowiązywać, musisz kliknąć link w tej wiadomości.',
    resendConfirmationEmail: 'Wyślij ponownie wiadomość e-mail z potwierdzeniem',
    cancelChange: 'Anuluj tę zmianę',
    firstName: 'Imię',
    lastName: 'Nazwisko',
    phone: 'Tel.',
    company: 'Firma',
    saveDetails: 'Zapisz szczegóły konta',
    changeEmailRequest: 'Zmień adres e-mail',
    job_profile: {
      label: "Wybierz profil zawodowy osoby w firmie",
      tooltip_msg: 'Wybierz główny profil stanowiska danej osoby. Jeśli użytkownik ma więcej niż jedną rolę podstawową, wybierz "Inni"',
    }
  },
  resetPassword: {
    instructions:
      'Hasło musi składać się co najmniej z sześciu znaków, zawierać co najmniej jedną cyfrę lub znak specjalny i nie może być takie samo jak adres e-mail.',
    currentPassword: 'Aktualne hasło',
    newPassword: 'nowe hasło',
    confirmNewPassword: 'Potwierdź nowe hasło'
  }
};

export default accountDetails;
